import {Breadcrumb, Button, Col, Form, InputGroup, Row} from 'react-bootstrap'
import {useCallback, useEffect, useState} from 'react'
import moment from 'moment'
import {toast} from 'react-toastify'
import {useLazyQuery} from '@apollo/client'
import {GET_ALL_CARRIERS} from '../../gql/queries/carriersQuery'
import {IResCarriers} from '../../types/carriers'
import {useNavigate} from 'react-router-dom'
import {parseId} from '../../helpers'
import {useDisclourse} from '../../hooks/useDisclourse'
import {ModalAddCarrier} from './components/ModalAddCarrier'
import {cleanVariables, PaginationUtils} from '../shared/PaginationUtils'
import {SIZE_PAGE_DEFAULT} from '../../helpers/consts'
import {PaginationSection} from '../shared/PaginationSection'

export const CarriersPage = () => {
  const navigate = useNavigate()
  const [gqlGetCarriers, {data, loading, error, refetch}] = useLazyQuery<IResCarriers>(
    GET_ALL_CARRIERS,
    {
      fetchPolicy: 'no-cache',
    }
  )

  const [dataArr, setDataArr] = useState<IResCarriers['allInsuranceOperators']['edges']>([])
  const {isOpen, onClose, onOpen} = useDisclourse()
  const [first, setFirst] = useState(SIZE_PAGE_DEFAULT)

  const [currentPage, setCurrentPage] = useState(1)
  let totalElements = data?.allInsuranceOperators?.totalCount ?? 0
  const totalPages = Math.ceil(totalElements / first)
  const {start, end} = PaginationUtils.getPaginationRange(currentPage, first, totalElements)
  const [searchText, setSearchText] = useState('')
  const [appliedSearchText, setAppliedSearchText] = useState('')

  const updatePage = (n: number) => {
    setCurrentPage(n)
  }

  const requestCarriers = useCallback(
    (name: string, page: number, pageSize: number) => {
      const variables = cleanVariables({
        first: pageSize,
        offset: (page - 1) * pageSize,
        name,
      })

      gqlGetCarriers({variables})
    },
    [gqlGetCarriers]
  )

  const handleFilters = useCallback(() => {
    const nextSearchText = searchText

    if (appliedSearchText !== nextSearchText) {
      setAppliedSearchText(nextSearchText)
    }

    if (currentPage !== 1) {
      setCurrentPage(1)
      return
    }

    requestCarriers(nextSearchText, 1, first)
  }, [appliedSearchText, currentPage, first, requestCarriers, searchText])

  useEffect(() => {
    const variables = cleanVariables({
      first,
      offset: (currentPage - 1) * first,
      name: appliedSearchText,
    })

    gqlGetCarriers({variables})
  }, [appliedSearchText, currentPage, first, gqlGetCarriers])

  useEffect(() => {
    if (!data) return
    const {edges} = data.allInsuranceOperators
    setDataArr(edges)
  }, [data])

  useEffect(() => {
    if (error) {
      toast.error(`Error: ${error.message}`)
    }
  }, [error])

  // if (dataArr.length === 0 && !isPag) {
  //   return <LoadingCarriers />
  // }

  return (
    <div className='policies-page'>
      <header className='header'>
        <Breadcrumb>
          <Breadcrumb.Item className='d-blok d-md-none'>
            <span>
              <i className='bi bi-list fs-1' />
            </span>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Carriers</Breadcrumb.Item>
        </Breadcrumb>
        <div className='d-flex align-items-center gap-2'>
          <Button
            size='sm'
            onClick={() => {
              onOpen()
            }}
          >
            <i className='bi bi-plus fs-3' /> New Carrier
          </Button>
        </div>
      </header>
      <Row className='policies'>
        <Col md={12} lg={12} sm={12} xl={12} className='container'>
          <div className='policies-container'>
            <div className='title-header'>
              <h3>All Carriers</h3>
            </div>
            <div className='filters-header'>
              <InputGroup>
                <Form.Control
                  placeholder='Type your query here...'
                  onChange={(e) => setSearchText(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault()
                      handleFilters()
                    }
                  }}
                  value={searchText}
                />
                <Button
                  onClick={() => handleFilters()}
                  variant='outline-success'
                  style={{border: '1px solid #dbdfe9'}}
                >
                  Search
                </Button>
              </InputGroup>
            </div>
            <div className='results-header'>
              <PaginationSection
                first={first}
                setFirst={(n) => {
                  setFirst(n)
                  setCurrentPage(1)
                  // setOffset(0)
                }}
                currentPage={currentPage}
                totalPages={totalPages}
                start={start}
                end={end}
                totalPolicies={totalElements}
                updatePage={updatePage}
                PaginationUtils={PaginationUtils}
              />
              <div className='col-md-3'>
                <div className='results-filter'>
                  <Col lg={12} md={12} sm={12} xs={12}></Col>
                </div>
              </div>
            </div>
            <div className='list-carrier table-scrollable table-container'>
              <table className='table-scrollable table-scroll  table table-striped table-hover '>
                <thead>
                  <tr role='row'>
                    <th className='fw-bold'>Name</th>
                    <th className='fw-bold d-none d-lg-table-cell text-center'>Commissions</th>
                    <th className='fw-bold d-none d-lg-table-cell text-center'>Policies</th>
                    <th className='fw-bold d-none d-lg-table-cell'>Created</th>
                    <th className='fw-bold d-none d-lg-table-cell text-center'>Actions</th>
                  </tr>
                </thead>
                <tbody className=''>
                  {dataArr.map(({node}) => (
                    <tr key={node.id}>
                      <td className='px-4'>{node.name}</td>
                      <td className='px-2 text-center'>
                        {node.policyInsuranceThroughSet.edges.length}
                      </td>
                      <td className='px-2 text-center'>{node.policies.edges.length}</td>
                      <td className='px-2'>{moment(node.created).format('DD MMM, YYYY')}</td>
                      <td className='px-2 text-center'>
                        <Button
                          size='sm'
                          onClick={(e) => navigate(`/carrier/${parseId(node.id)}`)}
                          disabled={loading}
                        >
                          Commission Rates
                        </Button>
                      </td>
                    </tr>
                  ))}
                  {/* {data?.allInsuranceOperators.pageInfo.hasNextPage && (
                    <tr>
                      <td colSpan={3}>
                        <div className='d-flex flex-center'>
                          <Button
                            size='sm'
                            onClick={() => {
                              setOffset((p) => p + 10)
                              setIsPag(true)
                            }}
                            disabled={loading}
                          >
                            {loading && <Spinner animation='border' size='sm' className='me-2' />}
                            Load more
                          </Button>
                        </div>
                      </td>
                    </tr>
                  )} */}
                </tbody>
              </table>
            </div>
          </div>
        </Col>
      </Row>
      {isOpen && <ModalAddCarrier refetch={refetch} isOpen={isOpen} onClose={onClose} />}
    </div>
  )
}

/*
<Row className='gy-2 mb-5'>
        {dataArr.map(({node}) => (
          <Col sm={12} md={6} lg={5} key={node.id}>
            <Card>
              <Card.Header>
                <Card.Title>
                  <Link to={`/carrier/${parseId(node.id)}`} className='text-info'>
                    {node.name}
                  </Link>
                </Card.Title>
                <div className='card-title'>
                  <div className='d-flex align-items-center gap-2'>
                    <button
                      className='text-primary'
                      style={{border: 0, backgroundColor: 'transparent'}}
                    >
                      <i className='bi bi-pencil-square fs-2' style={{color: 'inherit'}} />
                    </button>
                    <button
                      className='text-danger'
                      style={{border: 0, backgroundColor: 'transparent'}}
                    >
                      <i className='bi bi-trash fs-2' style={{color: 'inherit'}} />
                    </button>
                  </div>
                </div>
              </Card.Header>
              <Card.Body>
                <div className='d-flex flex-column gap-4'>
                  <div className='d-flex justify-content-between align-items-start border-bottom pb-4'>
                    <div className=' me-auto'>
                      <div className='fw-bold'>Commisions</div>
                    </div>
                    <Badge bg='primary' style={{color: 'white'}} pill>
                      {node.policyInsuranceThroughSet.edges.length}
                    </Badge>
                  </div>
                  <div className='d-flex justify-content-between align-items-start'>
                    <div className=' me-auto'>
                      <div className='fw-bold'>Policies</div>
                    </div>
                    <Badge bg='info' style={{color: 'white'}} pill>
                      {node.policies.edges.length}
                    </Badge>
                  </div>
                </div>
                <div className='mt-4 d-flex justify-content-end'>
                  <small>
                    <span className='fw-bold'>Created: </span>
                    {moment(node.created).format('DD MMM, YYYY')}
                  </small>
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
      <div>
        {dataArr.map(({node}, i) => (
          <div
            key={node.id}
            className={`d-flex align-items-center bg-light-${getColor(i)} rounded p-5 mb-7`}
          >
            begin::Icon
            <span className={`text-${getColor(i)} me-5`}>
              <KTIcon iconName='information' className={`text-${getColor(i)} fs-1 me-5`} />
            </span>
            end::Icon
            begin::Title
            <div className='flex-grow-1 me-2'>
              <h5 className='fw-bold text-gray-800 fs-6'>{node.name}</h5>
              <span className=' fw-semibold d-block'>
                <span>Created: </span>
                <span className='text-muted'>{moment(node.created).format('DD MMM YYYY')}</span>
              </span>
            </div>
             end::Title 
             begin::Lable 
            <button
              className={`bg-transparent border-0 fw-bold text-${getColor(i)} py-1`}
              onClick={() => {
                onOpen()
                setInfoEdit(node)
              }}
            >
              <i className={`bi bi-pencil fs-2 text-${getColor(i)}`} />
            </button>
            end::Lable 
          </div>
        ))}
      </div>
*/
